import './css/SchedulingSales.css'

import { ReactElement, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Space, Button, Row, Col, Table, DatePicker, Modal } from "antd"
import { CaretLeftOutlined, CaretRightOutlined, DeleteOutlined } from '@ant-design/icons'
import { baseAxiosNoInfo, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import { XinTool } from '../../tool/xinTool'
import _ from 'lodash'

const { Column } = Table

let rowKeys = { 'monday': '', 'tuesday': '', 'wednesday': '', 'thursday': '', 'friday': '', 'saturday': '', 'sunday': '' }
let testObj = { fetchFirstDay: '', fetchLastDay: '', thisMonth: 0, thisYear: 0, monthDateCount: 0 }

function toWeekWhich(date: number): string {
    let fixDate = date === 0 ? 6 : date - 1
    let keys = Object.keys(rowKeys)
    return keys[fixDate]
}

function toTableData(arr: [][]): {}[] {
    let tableData: {}[] = []

    arr.forEach(el => {
        let tableRow: any = { ...rowKeys }

        el.forEach((el2: any) => {
            tableRow[toWeekWhich(new Date(el2.date).getDay())] = {
                day: el2.day,
                fullDate: el2.date,
                work_time: [],
                id: [],
                have_user: []
            }
        })

        tableData.push(tableRow)
    })

    return tableData
}

type userData = {
    end_work_date: string
    id: string
    res_recover_schedule_list: {
        id: string,
        create_date: null | string
        create_user_id: null | string
        create_user_name: null | string
        employee_list_id: string
        end_work_turn: string
        remark: string
        start_work_turn: string
        update_date: null | string
        update_user_id: null | string
        update_user_name: null | string
        work_date: string
    }[]
    start_work_date: string
    store_list_id: string
    store_name: string
    user_name: string
}

type FetchDateObj = {
    fetchFirstDay: string,
    fetchLastDay: string,
    thisYear: number,
    thisMonth: number,
    monthDateCount: number,
    d: Date
}

export default function AddScheduling() {

    const d = new Date()
    const nowDate = `${d.getFullYear()}-${XinTool.toZero(d.getMonth() + 1)}-${XinTool.toZero(d.getDate())}`

    d.setDate(1)

    const [fetchDateObj, setFetchDateObj] = useState<FetchDateObj>({ fetchFirstDay: '', fetchLastDay: '', thisMonth: 0, thisYear: 0, monthDateCount: 0, d })
    const [tableData, setTableData] = useState<any>([])
    const [userData, setUserData] = useState<any | null>()
    const [storeID, setStoreID] = useState<string | undefined>()

    const handleSearch = (type: any, time: string) => {
        let store_id = storeID;
        let month: any = `${fetchDateObj.thisYear}-${digi(fetchDateObj.thisMonth)}`;

        for (let i of tableData) {
            for (let b in i) {
                if (i[b].have_user) {
                    i[b].have_user = []
                }
            }
        }

        if (type == 'noStore') {
            store_id = undefined
        }

        // 查询排班数据
        baseAxiosNoInfo('/markting_center/schedule/sales/list', {
            params: {
                store_id,
                month
            }
        }).then((res: any) => {
            setUserData(res)
        })
    }

    const delItem = (o: any, item: any) => {
        baseAxiosComplete.post('/markting_center/schedule/sales/delete', {
            id: item.id
        }).then((res: any) => {
            o[o.currentClick].have_user.map((citem: any, cindex: number) => {
                if (citem.id == item.id) {
                    o[o.currentClick].have_user.splice(cindex, 1)
                }
            })

            setFetchDateObj(o)
        })
    }

    const createRowElment = (obj: any, key: string, currentDate: string): ReactElement => {
        let row = (null)

        if (new Date(obj[key].fullDate) < new Date(currentDate)) {
            row = (<div className="scheduling-month-row disabled">
                <div className="num">{obj[key].day}</div>
                {obj[key].have_user != undefined ?
                    obj[key].have_user.map((item: any) => {
                        return (
                            <p className="work-time" key={item.id}>{item.user_name} {item.work_turn} </p>
                        )
                    })
                    :
                    ''
                }
            </div>)

        } else {
            row = (<div className="scheduling-month-row">
                <div className="num">{obj[key].day}</div>
                <div>
                    {obj[key].have_user != undefined ?
                        obj[key].have_user.map((item: any) => {
                            return (
                                <div className="flex-align" key={item.id}>
                                    <p className="work-time">{item.user_name} {item.work_turn} </p>
                                    <DeleteOutlined onClick={() => { delItem({ ...obj, currentClick: key }, item) }} />
                                </div>
                            )
                        })
                        :
                        ''
                    }
                </div>
            </div>)
        }

        return row
    }

    const onChanges = (value: any) => {
        setStoreID(value);

        if (value == undefined) {
            handleSearch('noStore', '')
        }
    }

    useEffect(() => {
        let o = { ...fetchDateObj }

        let thisYear = o.d.getFullYear()
        let thisMonth = o.d.getMonth() + 1
        let monthDateCount = new Date(thisYear, thisMonth, 0).getDate()

        o.fetchFirstDay = `${thisYear}-${XinTool.toZero(thisMonth)}-01`
        o.fetchLastDay = `${thisYear}-${XinTool.toZero(thisMonth)}-${XinTool.toZero(monthDateCount)}`

        o.thisMonth = thisMonth
        o.thisYear = thisYear
        o.monthDateCount = monthDateCount

        setFetchDateObj(o)
    }, [])

    // 计算月
    const changeMonth = (type: string) => {
        let obj = _.cloneDeep(fetchDateObj)

        let d = obj.d,
            monthNum = d.getMonth() + 1,
            thisMonth = type === 'decrease' ? --monthNum : ++monthNum,
            thisYear = d.getFullYear()

        if (thisMonth <= 0) {
            thisMonth = 12
            thisYear = d.getFullYear() - 1

        } else if (thisMonth > 12) {
            thisMonth = 1
            thisYear = d.getFullYear() + 1
        }

        let monthDateCount = new Date(thisYear, thisMonth, 0).getDate(),
            fetchFirstDay = `${thisYear}-${XinTool.toZero(thisMonth)}-01`,
            fetchLastDay = `${thisYear}-${XinTool.toZero(thisMonth)}-${XinTool.toZero(monthDateCount)}`

        obj.d.setFullYear(thisYear)
        obj.d.setMonth(thisMonth - 1)

        obj.thisMonth = thisMonth
        obj.thisYear = thisYear

        obj.fetchFirstDay = fetchFirstDay
        obj.fetchLastDay = fetchLastDay
        obj.monthDateCount = monthDateCount

        testObj = obj;
        setFetchDateObj(obj)
    }

    // 渲染排班数据
    useEffect(() => {
        if (userData) {
            let newTableData = _.cloneDeep(tableData)

            userData.forEach((el: any) => {
                newTableData.forEach((el2: any) => {
                    for (let attr in el2) {
                        if (el2[attr].fullDate === el.work_date) {
                            el2[attr].have_user.push({
                                id: el.id,
                                work_turn: el.work_turn,
                                user_name: el.user_name
                            })
                        }
                    }
                })
            })

            setTableData(newTableData)
        }
    }, [userData])

    useEffect(() => {
        let { fetchFirstDay, fetchLastDay } = fetchDateObj

        if (fetchFirstDay && fetchLastDay) {
            let dateArr = new Array(fetchDateObj.monthDateCount).fill({}).map((el, index) => ({ date: `${fetchDateObj.thisYear}-${XinTool.toZero(fetchDateObj.thisMonth)}-${XinTool.toZero(index + 1)}`, day: index + 1 }))
            let firstDayOfWeek = new Date(dateArr[0].date).getDay() === 0 ? 6 : new Date(dateArr[0].date).getDay() - 1

            let lastMonth = fetchDateObj.thisMonth - 1 === 0 ? 12 : fetchDateObj.thisMonth - 1
            let nextMonth = fetchDateObj.thisMonth + 1

            let lastMonthDayCount = new Date(fetchDateObj.thisYear, lastMonth, 0).getDate()
            let lastMonthRestArr = new Array(firstDayOfWeek).fill({}).map((el, index) => ({ date: `${lastMonth === 12 ? fetchDateObj.thisYear - 1 : fetchDateObj.thisYear}-${lastMonth}-${lastMonthDayCount - index}`, day: lastMonthDayCount - index })).reverse()

            let lastDayOfWeek = new Date(dateArr[dateArr.length - 1].date).getDay() === 0 ? 6 : new Date(dateArr[dateArr.length - 1].date).getDay() - 1
            let nextMonthRestArr = new Array(6 - lastDayOfWeek).fill({}).map((el, index) => ({ date: `${fetchDateObj.thisYear}-${nextMonth}-${index + 1}`, day: index + 1 }))

            dateArr.unshift(...lastMonthRestArr)
            dateArr.push(...nextMonthRestArr)

            let t: any = []
            let iLen = dateArr.length / 7

            for (let i = 0; i < iLen; i++) {
                t.push([])
            }

            for (let i = 0; i < iLen; i++) {
                for (let j = 0; j < 7; j++) {
                    t[i].push(dateArr[7 * i + j])
                }
            }

            setTableData(toTableData(t))
            handleSearch('', fetchFirstDay.slice(0, fetchFirstDay.length - 3))
        }
    }, [fetchDateObj])

    const digi = (val: number) => {
        if (val < 10) {
            return `0${val}`
        }

        return val
    }

    return <div className="common-page">
        {/* 营销中心 -> 销售管理 -> 销售排班 */}
        <BreadCrumb position={['营销中心', '销售排班']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={storeID} onChange={onChanges} valueProp="id" />
                </div>

                <Button style={{ marginRight: 5, marginBottom: 12 }} type="primary" onClick={() => { handleSearch('', '') }}>查询</Button>
                <Button style={{ marginRight: 5, marginBottom: 12 }}><Link to={"/salesman_scheduling_add"}>新增</Link></Button>
            </Space>
        </div>

        <div className="common-main">
            <div className="scheduling-month">
                <Row justify="center" wrap>
                    <Col className="date-range" >
                        <Space className="top">
                            <Button size="small" icon={<CaretLeftOutlined />} title="上个月" onClick={() => { changeMonth('decrease') }}></Button>
                            <span>{fetchDateObj.thisYear}年{XinTool.toZero(fetchDateObj.thisMonth)}月</span>
                            <Button size="small" icon={<CaretRightOutlined />} title="下个月" onClick={() => { changeMonth('incre') }}></Button>
                        </Space>

                        <Table dataSource={tableData} bordered={true} pagination={false} style={{ width: 1390 }} >
                            <Column width={170} title="星期一" key="monday" render={(tag: any) => createRowElment(tag, 'monday', nowDate)} />
                            <Column width={170} title="星期二" key="tuesday" render={(tag: any) => createRowElment(tag, 'tuesday', nowDate)} />
                            <Column width={170} title="星期三" key="wednesday" render={(tag: any) => createRowElment(tag, 'wednesday', nowDate)} />
                            <Column width={170} title="星期四" key="thursday" render={(tag: any) => createRowElment(tag, 'thursday', nowDate)} />
                            <Column width={170} title="星期五" key="friday" render={(tag: any) => createRowElment(tag, 'friday', nowDate)} />
                            <Column width={170} title="星期六" key="saturday" render={(tag: any) => createRowElment(tag, 'saturday', nowDate)} />
                            <Column width={170} title="星期天" key="sunday" render={(tag: any) => createRowElment(tag, 'sunday', nowDate)} />
                        </Table>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
}